import React, { useEffect, useState } from 'react';
import { Alert, Drawer, Icons, Sentiments } from '@sede-enterprise/shell-ds-react-framework';
import { Col, Row } from '../../components/flexbox/Flex';
import { ErrorCount } from '../styledComponent/StyledComponent';


interface ErrorDetailsProps {
    totalError: number;
    errorTypeWithDetails: {
        errorType: string;
        errorCodeWithDescs: {
            reasonCode: string;
            errorDescription: string;
        }[];
    }[];
}


const ErrorAlert = (props: {errorDetails:ErrorDetailsProps | undefined}) => {
    const [open, setOpen] = useState(false);
    const drawerActionMap = {
        cancel: {
            label: 'Cancel',
            action: () => setOpen(false),
        },
    };

    const [errorList, setErrorList] = useState<string[]>([]);
    useEffect(() => {
        setErrorList([]);
        props.errorDetails?.errorTypeWithDetails?.map((detail)=>{
            if (detail && detail.errorType){
                setErrorList((prevErrorList: string[]) => [...prevErrorList, detail.errorType]);
            }
        });
    },[]);

    
    return (
        <>
            <Alert iconVisibility={false} sentiment={Sentiments.Negative} style={{borderWidth:'2px'}}>
                <Row>
                    <Col size="85">
                        <span><strong>Error Type:</strong> 	{errorList.join(', ') }</span>
                    </Col>
                    <Col size="15">
                        <span>TOTAL ERRORS 
                            <ErrorCount>{props.errorDetails?.totalError}</ErrorCount>
                        </span>
                        <span style={{color:'#1C1C1C22', fontSize: '18px',paddingLeft:'15%'}}>|</span>
                        <span style={{float:'right', cursor:'pointer'}} onClick={() => setOpen(true)}><Icons.Menu height={20} width={20}/></span>
                    </Col>
                </Row>
            </Alert>

            <Drawer
                open={open}
                onClose={() => setOpen(false)}
                placement="right"
                header="ERRORS"
                closeButton={true}
                width="40%"
            >

                {props.errorDetails?.errorTypeWithDetails.map((errorDetail, index)=>(
                    <Alert iconVisibility={true} sentiment={Sentiments.Negative} icon={<Icons.CrossCircle/>} style={{marginBottom:'20px'}} key={'list'+index}>
                        <span><strong>Error Type: {errorDetail.errorType}</strong></span>
                        <ul>
                            {errorDetail.errorCodeWithDescs.map((errorDesc, index)=>(
                                <li key={'desc'+index}>Error code {errorDesc.reasonCode} - {errorDesc.errorDescription}</li>
                            ))}
                        </ul>
                    </Alert>
                ))}
            </Drawer>
        </>
    )
}

export default ErrorAlert;